export default {
  linkedIn: 'Continue with LinkedIn',

  //
  linkedinLogin: 'LinkedIn Login',
}
